import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Container } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { setQueryString, useQueryString } from '../common/helpers/queryString';
import { fetchChanges } from './RequestFormChangesActions';
import PageBreadcrumb from '../common/components/layout/PageBreadcrumb';
import RequestForChangesTable from './table/RequestForChangesTable';

function RequestForChangesPage() {
  const query = useQueryString();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const items = useSelector((state) => state.requests.get('items'));
  const totalItems = useSelector((state) => state.requests.get('totalItems'));

  const [searchParams, setSearchParams] = useState({
    offset: query.get('page') ? +query.get('page') - 1 : 0,
  });

  useEffect(() => {
    dispatch(fetchChanges(searchParams));
  }, [dispatch, searchParams]);

  const changeOffset = (value) => {
    setSearchParams((prevState) => ({ ...prevState, offset: value }));
    navigate(setQueryString(location, 'page', value + 1));
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'span', text: 'Requests For Changes' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Request For Changes" />
      <RequestForChangesTable
        data={{ items, total: totalItems }}
        offset={searchParams.offset}
        changeOffset={changeOffset}
      />
    </Container>
  );
}

export default RequestForChangesPage;
